import React from 'react'
import Img from 'gatsby-image'
import { getFluidGatsbyImage } from 'gatsby-source-sanity'
import { buildImageObj } from '../../lib/helpers'
import clientConfig from '../../../client-config'

const Image = ({ file, alt, ...rest }) => {
  const altText = alt || ''

  if (typeof file === 'object') {
    const restProps = { ...rest }
    const maxWidth = restProps.maxWidth || 1920
    const fluidProps = getFluidGatsbyImage(buildImageObj(file), { maxWidth }, clientConfig.sanity)
    return <Img fluid={fluidProps} alt={altText} {...rest} />
  }
  return <img src={file} alt={altText} {...rest} />
}

export default Image
